// assets
import { IconDashboard, IconUsers, IconLocation } from '@tabler/icons';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard-default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'places',
      title: 'Places',
      type: 'item',
      url: '/places',
      icon: IconLocation,
      breadcrumbs: false,
    },
    {
      id: 'addnewplace',
      title: 'Add Place',
      type: 'item',
      url: '/places/add-new',
      icon: IconUsers,
      breadcrumbs: false,
    },
    {
      id: 'visitors',
      title: 'Visitors',
      type: 'item',
      url: '/visitors',
      icon: IconUsers,
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
